module.exports = __webpack_public_path__ + "img/main_a_pic@2x.9312bf54.png";